import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.assign";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { pathToArray, getFromPath } from './utils';

var NopeObject = /*#__PURE__*/function () {
  function NopeObject(objectShape) {
    _classCallCheck(this, NopeObject);

    this.validationRules = [];
    this._type = 'object';
    this.objectShape = objectShape || {};
  }

  _createClass(NopeObject, [{
    key: "getType",
    value: function getType() {
      return this._type;
    }
  }, {
    key: "shape",
    value: function shape(_shape) {
      this.objectShape = Object.assign(Object.assign({}, this.objectShape), _shape);
      return this;
    }
  }, {
    key: "extend",
    value: function extend(Base) {
      this.objectShape = Object.assign(Object.assign({}, this.objectShape), Base.objectShape);
      return this;
    }
  }, {
    key: "noUnknown",
    value: function noUnknown() {
      var _this = this;

      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Input contains invalid keys';

      var rule = function rule(entry) {
        var objectIsDefined = false; // eslint-disable-next-line @typescript-eslint/no-unused-vars

        for (var _ in _this.objectShape) {
          objectIsDefined = true;
          break;
        }

        if (!objectIsDefined) {
          throw Error('noUnknown must be used with a schema');
        }

        var unknownKeys = false;

        for (var key in entry) {
          unknownKeys = unknownKeys || !(key in _this.objectShape);
        }

        if (unknownKeys) {
          return message;
        }
      };

      this.validationRules.push(rule);
      return this;
    }
  }, {
    key: "validate",
    value: function validate(entry, context, options) {
      var _iterator = _createForOfIteratorHelper(this.validationRules),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _rule = _step.value;

          var localErrors = _rule(entry);

          if (localErrors) {
            return localErrors;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var errors = {};
      var areErrors = false;

      for (var key in this.objectShape) {
        var rule = this.objectShape[key];
        var error = rule.validate(entry[key], entry, options);

        if (error && typeof error === 'string') {
          areErrors = true;
          errors[key] = error;

          if (options === null || options === void 0 ? void 0 : options.abortEarly) {
            return errors;
          }
        }
      }

      if (areErrors) {
        return errors;
      }

      return undefined;
    }
  }, {
    key: "validateAt",
    value: function validateAt(path, entry) {
      var _a, _b;

      var arrayPath = pathToArray(path);
      var validator = this.objectShape;

      var _iterator2 = _createForOfIteratorHelper(arrayPath),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var p = _step2.value;

          if (!isNaN(parseInt(p, 10))) {
            continue;
          }

          if ((_a = validator[p]) === null || _a === void 0 ? void 0 : _a.objectShape) {
            validator = validator[p].objectShape;
          } else if ((_b = validator[p]) === null || _b === void 0 ? void 0 : _b.ofShape) {
            validator = validator[p].ofShape.objectShape || validator[p].ofShape;
          } else {
            validator = validator[p];
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      var parentValue = getFromPath(path, entry, true);
      var value = getFromPath(path, entry);
      return validator.validate(value, parentValue);
    }
  }]);

  return NopeObject;
}();

export default NopeObject;